export const MUID = 'MUID'
export const STATUS = 'STATUS'
export const SUBJECT = 'SUBJECT'
export const SENDER = 'SENDER'
export const POINTS = 'POINTS'
export const DATE = 'DATE'
export const FORWARDTO = 'FORWARDTO'
export const EMAILBODY = 'EMAILBODY'
export const IS_LOADING = 'IS_LOADING'
export const PANELIST = 'PANELIST'
export const STARTTIME = 'STARTTIME'
export const ENDTIME = 'ENDTIME'
export const AGE='AGE'
export const PANELISTEMAIL='PANELISTEMAIL'
export const FIRSTNAME='FIRSTNAME'
export const LASTNAME='LASTNAME'
export const STATE='STATE'
export const FORWARDEDDATA='FORWARDEDDATA'
export const SUBJECTDATA='SUBJECTDATA'
export const HTMLBODY='HTMLBODY'
export const EMAILREAD='EMAILREAD'
export const PANELISTSCORE='PANELISTSCORE'
export const PANELISTCORE='PANELISTCORE'
export const INDEXNAME='INDEXNAME'
export const DELETED='DELETED'
